<lex-case-analytics-item [noDataInCase]="noDataInCase$">
        <div card-header-content-primary  *ngIf="productionJobSummary === null && !shouldShowLoader" [@appear]>
            <div>Productions <span>({{displayedProductionCount}}</span> of <span>{{caseProductionJobCount}})</span></div>
            <div>{{caseDocCount | number}}</div>
            <div>Documents <b>produced</b> across all productions</div>
        </div>
        <div card-header-content-primary *ngIf="productionJobSummary !== null && !shouldShowLoader" [@appear]>
            <div>{{productionJobSummary.title}}</div>
            <div>
                <b>{{productionJobSummary.producedDocCount | number}} </b>
            </div>
            <div>
                <span *ngIf="productionJobSummary.producedDocCount === 1">Document </span>
                <span *ngIf="productionJobSummary.producedDocCount !== 1">Documents </span>
                produced in this production
            </div>
        </div>


    <div card-body-content-chart *ngIf="chartData.datasets.length > 0" [ngClass]="{'loading': shouldShowLoader === true}">
        <canvas
            baseChart
            type="bar"
            [data]="chartData"
            [options]="ngChartOptions"
            [plugins]="ngChartPlugins"
            [legend]="true"
            (chartHover)="displayProductionJobSummary($event)"
            (chartClick)="selectProductionJob($event)">
        </canvas>
    </div>
  <div card-body-content-chart *ngIf="shouldShowLoader" style="display: flex; align-items: center; justify-content: center;">
    <i card-body-loading-icon class="fa-light fa-chart-waterfall fa-fade" style="font-size: 19.2vh;"></i>
  </div>

    <div card-header-no-content>
        <div>Productions</div>
        <div>0</div>
        <div>Documents <b>produced</b> across all productions</div>
    </div>
    <a card-no-content-button [routerLink]="['/', 'discovery', 'production-job']">
        <button mat-flat-button class="no-data-button">
            <span>Click here to add a production</span>
        </button>
    </a>
</lex-case-analytics-item>
